module.exports = __webpack_public_path__ + "img/wollust.0050bdfe.png";